/**
 * Org id stamped on built-in flow template definitions returned from the
 * `create*Flow()` factories. The `'system'` literal is a no-tenant
 * sentinel: the orchestrator overwrites it when persisting a fresh seed
 * (every row's `organization_id` is set to the caller's active org id
 * at insert time, falling back to `'system'` for the cross-tenant
 * template bucket). The constant exists so the in-memory
 * `FlowDefinition` returned from a template still satisfies the
 * `organizationId: z.string()` schema; nothing reads a row keyed under
 * this id from the database — the templated bucket is virtual.
 */
export const FLOW_TEMPLATE_SYSTEM_ORG_ID = 'system';
